import { useCallback, useMemo } from 'react';
import useLocalStorage from './useLocalStorage';

const useCart = (initialItems = []) => {
  const [items, setItems] = useLocalStorage('grain-bites-cart', initialItems);

  const addItem = useCallback(product => {
    setItems(currentItems => {
      const existingItem = currentItems.find(item => item.id === product.id);

      if (existingItem) {
        return currentItems.map(item => (
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        ));
      }

      return [...currentItems, { ...product, quantity: 1 }];
    });
  }, []);

  const changeQuantity = useCallback((id, quantity) => {
    setItems(currentItems => {
      if (quantity < 1) {
        return currentItems.filter(item => item.id !== id);
      }

      return currentItems.map(item => (
        item.id === id ? { ...item, quantity } : item
      ));
    });
  }, []);

  const removeItem = useCallback(id => {
    setItems(currentItems => currentItems.filter(item => item.id !== id));
  }, []);

  const clear = useCallback(() => {
    setItems([]);
  }, []);

  const itemCount = useMemo(
    () => items.reduce((total, item) => total + item.quantity, 0),
    [items]
  );

  const total = useMemo(
    () => items.reduce((sum, item) => sum + item.price * item.quantity, 0),
    [items]
  );

  return {
    items,
    addItem,
    changeQuantity,
    removeItem,
    clear,
    itemCount,
    total,
  };
};

export default useCart;
